<!-- Header Template Included - Starts -->
<app-header></app-header>
<!-- Header Templated Included - Ends -->
<div class="conatiner-fluid">
  <div class="pkgDashborad_tile" *ngIf="userRoleID == 5 || userRoleID == 9">
    <strong>{{'Edit Package Code' | translate}}</strong>
  </div>
</div>
<section class="part_details_tabs pad-top-15">
  <ul class="nav nav-tabs" id="partTab" role="tablist">
    <li class="nav-item">
      <a class="nav-link " *ngIf="userRoleID == 1 || userRoleID == 2 || userRoleID == 7 || userRoleID == 3" routerLink="package"
        routerLinkActive="active" id="suppPkgTab">{{'PKGDASHBORD' | translate}}</a>
      <!-- <a class="nav-link " *ngIf="userRoleID == 3" routerLink="package" routerLinkActive="active" id="logpPkgTab">Logistic Package Dashboard</a> -->
      <a class="nav-link " *ngIf="userRoleID == 4" routerLink="package" routerLinkActive="active" id="fusoPkgTab">Fuso Package Dashboard</a>
      <a class="nav-link " *ngIf="userRoleID == 5 || userRoleID == 9" routerLink="package" routerLinkActive="active" id="AdminPkgTab">{{'List of Supplier Package Code' | translate}}</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" id="createPkgTabSM" *ngIf="userRoleID == 2 ||userRoleID == 7" routerLinkActive="active" routerLink="newSMPackage">{{'CREATENEWPKG' | translate}}</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" id="createPkgTab" *ngIf="userRoleID == 1" routerLink="newPackage" routerLinkActive="active">{{'Create New Supplier Package' | translate}}</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" id="createPkgTab" *ngIf="userRoleID == 2 || userRoleID == 3 || userRoleID == 4 || userRoleID == 7" routerLink="newPackage"
        routerLinkActive="active">{{'CREATENEWFUSO' | translate}}</a>
    </li>
    <li class="nav-item">
          <a class="nav-link" id="fusoPkgList" *ngIf="userRoleID == 5 || userRoleID == 9" routerLink="AdminFusoPackage" routerLinkActive="active">{{'List of Fuso Package Code' | translate}}</a>
        </li>
  </ul>
</section>
<router-outlet></router-outlet>